import * as React from "react";
import { styled } from "@mui/material";
import { QuestionsIF } from "../../QuestionsIF";
import { PatientColorMap } from "../../../../layout/patientColorMap";
import {
  WaveArea,
  WaveAreaAlignment,
  WaveAreaPosition,
} from "../../../../style/waveStyles";
import { QualifiedFeature } from "fe-common/graphql";
import { VisitTypeSelectionButton } from "./visitTypeSelectionButton";
import { scrollableStyle } from "fe-common/ui/commonStyles";

//region [[ Styles ]]

const VisitTypeOverlayView = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%",
  zIndex: 100,
  background: PatientColorMap.White,

  "& .content": {
    justifyContent: "center",
  },
});

const VisitTypeWave = styled(WaveArea)({});

const QuestionText = styled("div")({
  color: PatientColorMap.Primary,
  fontSize: "19px",
  lineHeight: "25px",
  fontWeight: 700,
  width: "100%",
  textAlign: "center",
});

const VisitTypeSelectionArea = styled("div")({
  display: "flex",
  flexFlow: "column",
  minHeight: "calc(100vh - min(34vw, 198px) - 165px - 15px)", // Make room for the bottom and top waves
  marginTop: "min(34vw, 198px)", //Make it grow with the width of the screen
  marginBottom: "15px",
  padding: "0 25px",
  zIndex: 1503,
  position: "relative",
});

const ScrollContainer = styled("div")({
  position: "relative",
  ...scrollableStyle,
  height: "fit-content",
  minHeight: "100%",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface VisitTypeOverlayProps extends QuestionsIF {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const VisitTypeOverlay = ({ ...props }: VisitTypeOverlayProps) => {
  const visitTypeOptions = props.question?.suggestions;

  if (!props.question)
    return <span>visit-type-overlay: NO props.question!</span>;

  const handleVisitAnswered = (visitType: QualifiedFeature) => {
    const notSelectedOptions = visitTypeOptions
      .filter((op) => op.suggestion.id !== visitType.id)
      .map((q) => ({ ...q.suggestion, negate: true }));

    props.onAnswer([visitType, ...notSelectedOptions]);
  };

  return (
    <VisitTypeOverlayView className={"visit-type-overlay"}>
      <ScrollContainer className={"scroll-container"}>
        <VisitTypeWave
          alignment={WaveAreaAlignment.Top}
          position={WaveAreaPosition.Absolute}
          color={PatientColorMap.Header}
          noShadow
        >
          <QuestionText>{props.question.question.text}</QuestionText>
        </VisitTypeWave>
        <VisitTypeSelectionArea className={"visit-type-selection-area"}>
          {visitTypeOptions.map((option, index) => (
            <VisitTypeSelectionButton
              key={`${option.suggestion.id}_${index}`}
              visitType={option.suggestion}
              onVisitSelected={handleVisitAnswered}
            />
          ))}
        </VisitTypeSelectionArea>
      </ScrollContainer>
    </VisitTypeOverlayView>
  );
};
